import React, { useEffect } from 'react';
import { PurchaseOrderForm } from '../../Components/Form';
import { FormLayout } from '../../Components';
import { NewPurchaseOrderIcon } from '../../Assets/Navigation/NavigationIcons';
import { getObjFromLS } from '../../Helpers';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AddPurchaseOrder = ({ handleToast }) => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'Add Purcahse Orders';
  }, []);
  const handleRedirection = () => {
    const { search = '' } = location;
    let dataFromLS = getObjFromLS('module');
    if (dataFromLS.moduleName === 'contacts' && search) return '/contacts';
    else return '/purchaseorders';
  };

  return (
    <FormLayout
      title={t('PurchaseOrder.create_purchase_order')}
      Icon={NewPurchaseOrderIcon}
      // closeUrl="/purchaseorders"
      closeUrl={handleRedirection()}
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <PurchaseOrderForm type="add" handleToast={handleToast} />
    </FormLayout>
  );
};

export default AddPurchaseOrder;
